import { SharePointMetadataBooleans } from "../../../../config/sharepointConstants";
import { ISharepointSearchInput } from "../../../../interfaces/advancedSearch/ISharepointSearchInput";

export class FieldHelper {
  static addMissingField = (
    inputValuesToSearchFields: ISharepointSearchInput[],
    internalName: string,
    type: string
  ): ISharepointSearchInput[] => {
    return [
      ...inputValuesToSearchFields,
      {
        index: inputValuesToSearchFields.length,
        internalName: internalName,
        value: "",
        type: type,
        siteId: null,
        webUrl: null,
        documentLibrary: null
      }
    ];
  };

  static setupInputValues = (item, index): ISharepointSearchInput => {
    return {
      index: index,
      internalName: item.InternalName,
      value: null,
      type: item.xml.Percentage && item.xml.Percentage !== SharePointMetadataBooleans.false ? `${item.xml.Type}Percentage` : item.xml.Type,
      displayName: item.xml.DisplayName,
      siteId: item.siteId,
      webUrl: item.webUrl,
      documentLibrary: item.documentLibrary,
      choices: item.Choices,
      xml: item.xml
    };
  };
}
